<template>
  <tr class="even:bg-white odd:bg-gray-50">
    <td class="px-4 py-4 whitespace-nowrap text-sm font-medium text-gray-900 tabular-nums">
      {{ accOrder.number }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 text-right">
      {{ dateCreated }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ accOrder.lineItemsSumQuantity }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500">
      {{ paymentMethod }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm">
      <span
        class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium"
        :class="statusStyle"
      >
        {{ accOrder.status }}
      </span>
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ shippingTotal }}
    </td>
    <td class="px-4 py-4 whitespace-nowrap text-sm text-gray-500 tabular-nums text-right">
      {{ total }}
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import numbro from '@/utils/numbro';

export default {
  props: {
    accOrder: {
      type: Object,
      required: true,
    },
  },
  computed: {
    dateCreated() {
      return moment(this.accOrder.dateCreated).format('ddd D MMM Y');
    },
    shippingTotal() {
      return numbro(this.accOrder.shippingTotal).formatCurrency({
        mantissa: 2,
        spaceSeparated: true,
      });
    },
    total() {
      return numbro(this.accOrder.total).formatCurrency({ mantissa: 2, spaceSeparated: true });
    },
    statusStyle() {
      const styleByStatus = {
        processing: 'bg-blue-100 text-blue-800',
        cancelled: 'bg-red-100 text-red-800',
        completed: 'bg-green-100 text-green-800',
        default: 'bg-gray-100 text-gray-800',
      };

      return styleByStatus[this.accOrder.status] || styleByStatus.default;
    },
    paymentMethod() {
      const paymentMethods = {
        cod: 'Cash on Delivery',
        cc: 'Credit Card',
        bacs: 'Direct Bank Transfer',
        cash: 'Cash',
      };

      return paymentMethods?.[this.accOrder.paymentMethod] || this.accOrder.paymentMethod;
    },
  },
};
</script>
